import {
    CREATE_PAYMENT_ADVICE,
    CREATE_PAYMENT_ADVICE_ERROR,
    CREATE_PAYMENT_ADVICE_RESET,
    CREATE_PAYMENT_ADVICE_SUCCESS,
    CREATE_PO,
    CREATE_PO_ERROR,
    CREATE_PO_RESET,
    CREATE_PO_SUCCESS,
    CREATE_RECEIVE_PO,
    CREATE_RECEIVE_PO_ERROR,
    CREATE_RECEIVE_PO_RESET,
    CREATE_RECEIVE_PO_SUCCESS,
    CREATE_RETURN_PO,
    CREATE_RETURN_PO_ERROR,
    CREATE_RETURN_PO_RESET,
    CREATE_RETURN_PO_SUCCESS,
    GET_APPROVAL_PAYMENT_ADVICE_LIST,
    GET_APPROVAL_PAYMENT_ADVICE_LIST_ERROR,
    GET_APPROVAL_PAYMENT_ADVICE_LIST_RESET,
    GET_APPROVAL_PAYMENT_ADVICE_LIST_SUCCESS,
    GET_GENERAL_PO_PRODUCT_LIST,
    GET_GENERAL_PO_PRODUCT_LIST_ERROR,
    GET_GENERAL_PO_PRODUCT_LIST_RESET,
    GET_GENERAL_PO_PRODUCT_LIST_SUCCESS,
    GET_PAYMENT_ADVICE_LIST,
    GET_PAYMENT_ADVICE_LIST_ERROR,
    GET_PAYMENT_ADVICE_LIST_RESET,
    GET_PAYMENT_ADVICE_LIST_SUCCESS,
    GET_PAYMENT_ADVICE_PRODUCTS,
    GET_PAYMENT_ADVICE_PRODUCTS_ERROR,
    GET_PAYMENT_ADVICE_PRODUCTS_RESET,
    GET_PAYMENT_ADVICE_PRODUCTS_SUCCESS,
    GET_PO_LIST,
    GET_PO_LIST_ERROR,
    GET_PO_LIST_SUCCESS,
    GET_PO_PRODUCT_LIST,
    GET_PO_PRODUCT_LIST_ERROR,
    GET_PO_PRODUCT_LIST_SUCCESS,
    GET_PO_PRODUCTS_BY_PO_ID,
    GET_PO_PRODUCTS_BY_PO_ID_ERROR,
    GET_PO_PRODUCTS_BY_PO_ID_RESET,
    GET_PO_PRODUCTS_BY_PO_ID_SUCCESS,
    GET_PO_PRODUCTS_BY_SHOP_ID,
    GET_PO_PRODUCTS_BY_SHOP_ID_ERROR,
    GET_PO_PRODUCTS_BY_SHOP_ID_RESET,
    GET_PO_PRODUCTS_BY_SHOP_ID_SUCCESS,
    GET_PO_STORE_LOCATION,
    GET_PO_STORE_LOCATION_ERROR,
    GET_PO_STORE_LOCATION_RESET,
    GET_PO_STORE_LOCATION_SUCCESS,
    GET_RECEIVE_PO_LIST,
    GET_RECEIVE_PO_LIST_ERROR,
    GET_RECEIVE_PO_LIST_SUCCESS,
    GET_RETURN_PO_LIST,
    GET_RETURN_PO_LIST_ERROR,
    GET_RETURN_PO_LIST_SUCCESS,
    GET_SELLER_DATA_BY_SHOP_ID,
    GET_SELLER_DATA_BY_SHOP_ID_ERROR,
    GET_SELLER_DATA_BY_SHOP_ID_RESET,
    GET_SELLER_DATA_BY_SHOP_ID_SUCCESS,
    GET_VENDOR_ACCOUNT_DETAILS,
    GET_VENDOR_ACCOUNT_DETAILS_ERROR,
    GET_VENDOR_ACCOUNT_DETAILS_RESET,
    GET_VENDOR_ACCOUNT_DETAILS_SUCCESS,
    GET_VENDOR_PAYMENT_DETAILS,
    GET_VENDOR_PAYMENT_DETAILS_ERROR,
    GET_VENDOR_PAYMENT_DETAILS_RESET,
    GET_VENDOR_PAYMENT_DETAILS_SUCCESS,
    UPDATE_RECEIVE_PO,
    UPDATE_RECEIVE_PO_ERROR,
    UPDATE_RECEIVE_PO_RESET,
    UPDATE_RECEIVE_PO_SUCCESS,
    GET_PAYMENT_ADVICE_EXCEL_REPORT,
    GET_PAYMENT_ADVICE_EXCEL_REPORT_SUCCESS,
    GET_PAYMENT_ADVICE_EXCEL_REPORT_ERROR
} from "../actions/purchaseOrderAction"

const initialState = {
    getPOProductsData: {},
    POCreateData: {},
    getPOListData: {},
    getGeneralPOProductsData: {},
    getPOproductsByPOIdData: {},
    getPOproductsByShopIdData: {},
    ReceivePOCreateData: {},
    getStoreLocationData: {},
    getReceivePOListData: {},
    ReceivePOUpdateData: {},
    paymentAdviceCreateData: {},
    getSellerDataByShopIdData: {},
    getPaymentAdviceProductsData: {},
    getVendorPaymentDetailsData: {},
    getPaymentAdviseListData: {},
    getApprovalPaymentAdviseListData: {},
    ReturnPOCreateData: {},
    getReturnPOListData: {},
    getVendorAccountDetailsData: {},
    getPaymentAdviceExcelReportData: {},

    getPOProductsDataLoading: false,
    getPOProductsDataLoaded: false,
    getPOProductsDataError: null,

    POCreateDataLoading: false,
    POCreateDataLoaded: false,
    POCreateDataError: null,

    getPOListDataLoading: false,
    getPOListDataLoaded: false,
    getPOListDataError: null,

    getGeneralPOProductsDataLoading: false,
    getGeneralPOProductsDataLoaded: false,
    getGeneralPOProductsDataError: null,

    getPOproductsByPOIdLoading: false,
    getPOproductsByPOIdLoaded: false,
    getPOproductsByPOIdError: null,

    getPOproductsByShopIdLoading: false,
    getPOproductsByShopIdLoaded: false,
    getPOproductsByShopIdError: null,

    ReceivePOCreateLoading: false,
    ReceivePOCreateLoaded: false,
    ReceivePOCreateError: null,

    getStoreLocationLoading: false,
    getStoreLocationLoaded: false,
    getStoreLocationError: null,

    getReceivePOListLoading: false,
    getReceivePOListLoaded: false,
    getReceivePOListError: null,

    ReceivePOUpdateLoading: false,
    ReceivePOUpdateLoaded: false,
    ReceivePOUpdateError: null,

    paymentAdviceCreateLoading: false,
    paymentAdviceCreateLoaded: false,
    paymentAdviceCreateError: null,

    getSellerDataByShopIdLoading: false,
    getSellerDataByShopIdLoaded: false,
    getSellerDataByShopIdError: null,

    getPaymentAdviceProductsLoading: false,
    getPaymentAdviceProductsLoaded: false,
    getPaymentAdviceProductsError: null,

    getVendorPaymentDetailsLoading: false,
    getVendorPaymentDetailsLoaded: false,
    getVendorPaymentDetailsError: null,

    getPaymentAdviseListLoading: false,
    getPaymentAdviseListLoaded: false,
    getPaymentAdviseListError: null,

    getApprovalPaymentAdviseListLoading: false,
    getApprovalPaymentAdviseListLoaded: false,
    getApprovalPaymentAdviseListError: null,

    ReturnPOCreateLoading: false,
    ReturnPOCreateLoaded: false,
    ReturnPOCreateError: null,

    getReturnPOListLoading: false,
    getReturnPOListLoaded: false,
    getReturnPOListError: null,

    getVendorAccountDetailsLoading: false,
    getVendorAccountDetailsLoaded: false,
    getVendorAccountDetailsError: null,

    getPaymentAdviceExcelReportLoading: false,
    getPaymentAdviceExcelReportLoaded: false,
    getPaymentAdviceExcelReportError: null,
}

export default function purchaseOrderReducer(state = initialState, action) {
    switch (action.type) {

        case GET_PO_PRODUCT_LIST:
            return {
                ...state,
                getPOProductsDataLoading: true,
                getPOProductsDataLoaded: false,
                getPOProductsDataError: null,
            }

        case GET_PO_PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                getPOProductsDataLoading: false,
                getPOProductsDataLoaded: true,
                getPOProductsData: action.payload.success,
            }

        case GET_PO_PRODUCT_LIST_ERROR:
            return {
                ...state,
                getPOProductsDataLoading: false,
                getPOProductsDataLoaded: false,
                getPOProductsDataError: action.payload.error,
                getPOProductsData: [],
            }


        case CREATE_PO:
            return {
                ...state,
                POCreateDataLoading: true,
                POCreateDataLoaded: false,
                POCreateDataError: null,
            }

        case CREATE_PO_SUCCESS:
            return {
                ...state,
                POCreateDataLoading: false,
                POCreateDataLoaded: true,
                POCreateData: action.payload.success,
            }

        case CREATE_PO_ERROR:
            return {
                ...state,
                POCreateDataLoading: false,
                POCreateDataLoaded: false,
                POCreateDataError: action.payload.error,
                POCreateData: [],
            }

        case CREATE_PO_RESET:
            return {
                ...state,
                POCreateDataLoading: false,
                POCreateDataLoaded: false,
                POCreateDataError: null,
                POCreateData: {},
            }

        case GET_PO_LIST:
            return {
                ...state,
                getPOListDataLoading: true,
                getPOListDataLoaded: false,
                getPOListDataError: null,
            }

        case GET_PO_LIST_SUCCESS:
            return {
                ...state,
                getPOListDataLoading: false,
                getPOListDataLoaded: true,
                getPOListData: action.payload.success,
            }

        case GET_PO_LIST_ERROR:
            return {
                ...state,
                getPOListDataLoading: false,
                getPOListDataLoaded: false,
                getPOListDataError: action.payload.error,
                getPOListData: [],
            }

        case GET_GENERAL_PO_PRODUCT_LIST:
            return {
                ...state,
                getGeneralPOProductsDataLoading: true,
                getGeneralPOProductsDataLoaded: false,
                getGeneralPOProductsDataError: null,
            }

        case GET_GENERAL_PO_PRODUCT_LIST_SUCCESS:
            return {
                ...state,
                getGeneralPOProductsDataLoading: false,
                getGeneralPOProductsDataLoaded: true,
                getGeneralPOProductsData: action.payload.success,
            }

        case GET_GENERAL_PO_PRODUCT_LIST_ERROR:
            return {
                ...state,
                getGeneralPOProductsDataLoading: false,
                getGeneralPOProductsDataLoaded: false,
                getGeneralPOProductsDataError: action.payload.error,
                getGeneralPOProductsData: [],
            }
        case GET_GENERAL_PO_PRODUCT_LIST_RESET:
            return {
                ...state,
                getGeneralPOProductsDataLoading: false,
                getGeneralPOProductsDataLoaded: false,
                getGeneralPOProductsDataError: null,
                getGeneralPOProductsData: {},
            }

        case GET_PO_PRODUCTS_BY_PO_ID:
            return {
                ...state,
                getPOproductsByPOIdLoading: true,
                getPOproductsByPOIdLoaded: false,
                getPOproductsByPOIdError: null,
            }

        case GET_PO_PRODUCTS_BY_PO_ID_SUCCESS:
            return {
                ...state,
                getPOproductsByPOIdLoading: false,
                getPOproductsByPOIdLoaded: true,
                getPOproductsByPOIdData: action.payload.success,
            }

        case GET_PO_PRODUCTS_BY_PO_ID_ERROR:
            return {
                ...state,
                getPOproductsByPOIdLoading: false,
                getPOproductsByPOIdLoaded: false,
                getPOproductsByPOIdError: action.payload.error,
                getPOproductsByPOIdData: [],
            }
        case GET_PO_PRODUCTS_BY_PO_ID_RESET:
            return {
                ...state,
                getPOproductsByPOIdLoading: false,
                getPOproductsByPOIdLoaded: false,
                getPOproductsByPOIdError: null,
                getPOproductsByPOIdData: {},
            }

        case GET_PO_PRODUCTS_BY_SHOP_ID:
            return {
                ...state,
                getPOproductsByShopIdLoading: true,
                getPOproductsByShopIdLoaded: false,
                getPOproductsByShopIdError: null,
            }

        case GET_PO_PRODUCTS_BY_SHOP_ID_SUCCESS:
            return {
                ...state,
                getPOproductsByShopIdLoading: false,
                getPOproductsByShopIdLoaded: true,
                getPOproductsByShopIdData: action.payload.success,
            }

        case GET_PO_PRODUCTS_BY_SHOP_ID_ERROR:
            return {
                ...state,
                getPOproductsByShopIdLoading: false,
                getPOproductsByShopIdLoaded: false,
                getPOproductsByShopIdError: action.payload.error,
                getPOproductsByShopIdData: [],
            }
        case GET_PO_PRODUCTS_BY_SHOP_ID_RESET:
            return {
                ...state,
                getPOproductsByShopIdLoading: false,
                getPOproductsByShopIdLoaded: false,
                getPOproductsByShopIdError: null,
                getPOproductsByShopIdData: {},
            }

        case CREATE_RECEIVE_PO:
            return {
                ...state,
                ReceivePOCreateLoading: true,
                ReceivePOCreateLoaded: false,
                ReceivePOCreateError: null,
            }

        case CREATE_RECEIVE_PO_SUCCESS:
            return {
                ...state,
                ReceivePOCreateLoading: false,
                ReceivePOCreateLoaded: true,
                ReceivePOCreateData: action.payload.success,
            }

        case CREATE_RECEIVE_PO_ERROR:
            return {
                ...state,
                ReceivePOCreateLoading: false,
                ReceivePOCreateLoaded: false,
                ReceivePOCreateError: action.payload.error,
                ReceivePOCreateData: [],
            }

        case CREATE_RECEIVE_PO_RESET:
            return {
                ...state,
                ReceivePOCreateLoading: false,
                ReceivePOCreateLoaded: false,
                ReceivePOCreateError: null,
                ReceivePOCreateData: {},
            }

        case GET_PO_STORE_LOCATION:
            return {
                ...state,
                getStoreLocationLoading: true,
                getStoreLocationLoaded: false,
                getStoreLocationError: null,
            }

        case GET_PO_STORE_LOCATION_SUCCESS:
            return {
                ...state,
                getStoreLocationLoading: false,
                getStoreLocationLoaded: true,
                getStoreLocationData: action.payload.success,
            }

        case GET_PO_STORE_LOCATION_ERROR:
            return {
                ...state,
                getStoreLocationLoading: false,
                getStoreLocationLoaded: false,
                getStoreLocationError: action.payload.error,
                getStoreLocationData: [],
            }
        case GET_PO_STORE_LOCATION_RESET:
            return {
                ...state,
                getStoreLocationLoading: false,
                getStoreLocationLoaded: false,
                getStoreLocationError: null,
                getStoreLocationData: {},
            }

        case GET_RECEIVE_PO_LIST:
            return {
                ...state,
                getReceivePOListLoading: true,
                getReceivePOListLoaded: false,
                getReceivePOListError: null,
            }

        case GET_RECEIVE_PO_LIST_SUCCESS:
            return {
                ...state,
                getReceivePOListLoading: false,
                getReceivePOListLoaded: true,
                getReceivePOListData: action.payload.success,
            }

        case GET_RECEIVE_PO_LIST_ERROR:
            return {
                ...state,
                getReceivePOListLoading: false,
                getReceivePOListLoaded: false,
                getReceivePOListError: action.payload.error,
                getReceivePOListData: [],
            }

        case UPDATE_RECEIVE_PO:
            return {
                ...state,
                ReceivePOUpdateLoading: true,
                ReceivePOUpdateLoaded: false,
                ReceivePOUpdateError: null,
            }

        case UPDATE_RECEIVE_PO_SUCCESS:
            return {
                ...state,
                ReceivePOUpdateLoading: false,
                ReceivePOUpdateLoaded: true,
                ReceivePOUpdateData: action.payload.success,
            }

        case UPDATE_RECEIVE_PO_ERROR:
            return {
                ...state,
                ReceivePOUpdateLoading: false,
                ReceivePOUpdateLoaded: false,
                ReceivePOUpdateError: action.payload.error,
                ReceivePOUpdateData: [],
            }

        case UPDATE_RECEIVE_PO_RESET:
            return {
                ...state,
                ReceivePOUpdateLoading: false,
                ReceivePOUpdateLoaded: false,
                ReceivePOUpdateError: null,
                ReceivePOUpdateData: {},
            }

        case GET_SELLER_DATA_BY_SHOP_ID:
            return {
                ...state,
                getSellerDataByShopIdLoading: true,
                getSellerDataByShopIdLoaded: false,
                getSellerDataByShopIdError: null,
            }

        case GET_SELLER_DATA_BY_SHOP_ID_SUCCESS:
            return {
                ...state,
                getSellerDataByShopIdLoading: false,
                getSellerDataByShopIdLoaded: true,
                getSellerDataByShopIdData: action.payload.success,
            }

        case GET_SELLER_DATA_BY_SHOP_ID_ERROR:
            return {
                ...state,
                getSellerDataByShopIdLoading: false,
                getSellerDataByShopIdLoaded: false,
                getSellerDataByShopIdError: action.payload.error,
                getSellerDataByShopIdData: [],
            }
        case GET_SELLER_DATA_BY_SHOP_ID_RESET:
            return {
                ...state,
                getSellerDataByShopIdLoading: false,
                getSellerDataByShopIdLoaded: false,
                getSellerDataByShopIdError: null,
                getSellerDataByShopIdData: {},
            }

        case CREATE_PAYMENT_ADVICE:
            return {
                ...state,
                paymentAdviceCreateLoading: true,
                paymentAdviceCreateLoaded: false,
                paymentAdviceCreateError: null,
            }

        case CREATE_PAYMENT_ADVICE_SUCCESS:
            return {
                ...state,
                paymentAdviceCreateLoading: false,
                paymentAdviceCreateLoaded: true,
                paymentAdviceCreateData: action.payload.success,
            }

        case CREATE_PAYMENT_ADVICE_ERROR:
            return {
                ...state,
                paymentAdviceCreateLoading: false,
                paymentAdviceCreateLoaded: false,
                paymentAdviceCreateError: action.payload.error,
                paymentAdviceCreateData: [],
            }

        case CREATE_PAYMENT_ADVICE_RESET:
            return {
                ...state,
                paymentAdviceCreateLoading: false,
                paymentAdviceCreateLoaded: false,
                paymentAdviceCreateError: null,
                paymentAdviceCreateData: {},
            }

        case GET_PAYMENT_ADVICE_PRODUCTS:
            return {
                ...state,
                getPaymentAdviceProductsLoading: true,
                getPaymentAdviceProductsLoaded: false,
                getPaymentAdviceProductsError: null,
            }

        case GET_PAYMENT_ADVICE_PRODUCTS_SUCCESS:
            return {
                ...state,
                getPaymentAdviceProductsLoading: false,
                getPaymentAdviceProductsLoaded: true,
                getPaymentAdviceProductsData: action.payload.success,
            }

        case GET_PAYMENT_ADVICE_PRODUCTS_ERROR:
            return {
                ...state,
                getPaymentAdviceProductsLoading: false,
                getPaymentAdviceProductsLoaded: false,
                getPaymentAdviceProductsError: action.payload.error,
                getPaymentAdviceProductsData: [],
            }
        case GET_PAYMENT_ADVICE_PRODUCTS_RESET:
            return {
                ...state,
                getPaymentAdviceProductsLoading: false,
                getPaymentAdviceProductsLoaded: false,
                getPaymentAdviceProductsError: null,
                getPaymentAdviceProductsData: {},
            }

        case GET_VENDOR_PAYMENT_DETAILS:
            return {
                ...state,
                getVendorPaymentDetailsLoading: true,
                getVendorPaymentDetailsLoaded: false,
                getVendorPaymentDetailsError: null,
            }

        case GET_VENDOR_PAYMENT_DETAILS_SUCCESS:
            return {
                ...state,
                getVendorPaymentDetailsLoading: false,
                getVendorPaymentDetailsLoaded: true,
                getVendorPaymentDetailsData: action.payload.success,
            }

        case GET_VENDOR_PAYMENT_DETAILS_ERROR:
            return {
                ...state,
                getVendorPaymentDetailsLoading: false,
                getVendorPaymentDetailsLoaded: false,
                getVendorPaymentDetailsError: action.payload.error,
                getVendorPaymentDetailsData: [],
            }
        case GET_VENDOR_PAYMENT_DETAILS_RESET:
            return {
                ...state,
                getVendorPaymentDetailsLoading: false,
                getVendorPaymentDetailsLoaded: false,
                getVendorPaymentDetailsError: null,
                getVendorPaymentDetailsData: {},
            }

        case GET_PAYMENT_ADVICE_LIST:
            return {
                ...state,
                getPaymentAdviseListLoading: true,
                getPaymentAdviseListLoaded: false,
                getPaymentAdviseListError: null,
            }

        case GET_PAYMENT_ADVICE_LIST_SUCCESS:
            return {
                ...state,
                getPaymentAdviseListLoading: false,
                getPaymentAdviseListLoaded: true,
                getPaymentAdviseListData: action.payload.success,
            }

        case GET_PAYMENT_ADVICE_LIST_ERROR:
            return {
                ...state,
                getPaymentAdviseListLoading: false,
                getPaymentAdviseListLoaded: false,
                getPaymentAdviseListError: action.payload.error,
                getPaymentAdviseListData: [],
            }
        case GET_PAYMENT_ADVICE_LIST_RESET:
            return {
                ...state,
                getPaymentAdviseListLoading: false,
                getPaymentAdviseListLoaded: false,
                getPaymentAdviseListError: null,
                getPaymentAdviseListData: {},
            }

        case CREATE_RETURN_PO:
            return {
                ...state,
                ReturnPOCreateLoading: true,
                ReturnPOCreateLoaded: false,
                ReturnPOCreateError: null,
            }

        case CREATE_RETURN_PO_SUCCESS:
            return {
                ...state,
                ReturnPOCreateLoading: false,
                ReturnPOCreateLoaded: true,
                ReturnPOCreateData: action.payload.success,
            }

        case CREATE_RETURN_PO_ERROR:
            return {
                ...state,
                ReturnPOCreateLoading: false,
                ReturnPOCreateLoaded: false,
                ReturnPOCreateError: action.payload.error,
                ReturnPOCreateData: [],
            }

        case CREATE_RETURN_PO_RESET:
            return {
                ...state,
                ReturnPOCreateLoading: false,
                ReturnPOCreateLoaded: false,
                ReturnPOCreateError: null,
                ReturnPOCreateData: {},
            }

        case GET_RETURN_PO_LIST:
            return {
                ...state,
                getReturnPOListLoading: true,
                getReturnPOListLoaded: false,
                getReturnPOListError: null,
            }

        case GET_RETURN_PO_LIST_SUCCESS:
            return {
                ...state,
                getReturnPOListLoading: false,
                getReturnPOListLoaded: true,
                getReturnPOListData: action.payload.success,
            }

        case GET_RETURN_PO_LIST_ERROR:
            return {
                ...state,
                getReturnPOListLoading: false,
                getReturnPOListLoaded: false,
                getReturnPOListError: action.payload.error,
                getReturnPOListData: [],
            }


        case GET_VENDOR_ACCOUNT_DETAILS:
            return {
                ...state,
                getVendorAccountDetailsLoading: true,
                getVendorAccountDetailsLoaded: false,
                getVendorAccountDetailsError: null,
            }

        case GET_VENDOR_ACCOUNT_DETAILS_SUCCESS:
            return {
                ...state,
                getVendorAccountDetailsLoading: false,
                getVendorAccountDetailsLoaded: true,
                getVendorAccountDetailsData: action.payload.success,
            }

        case GET_VENDOR_ACCOUNT_DETAILS_ERROR:
            return {
                ...state,
                getVendorAccountDetailsLoading: false,
                getVendorAccountDetailsLoaded: false,
                getVendorAccountDetailsError: action.payload.error,
                getVendorAccountDetailsData: [],
            }
        case GET_VENDOR_ACCOUNT_DETAILS_RESET:
            return {
                ...state,
                getVendorAccountDetailsLoading: false,
                getVendorAccountDetailsLoaded: false,
                getVendorAccountDetailsError: null,
                getVendorAccountDetailsData: {},
            }

        case GET_APPROVAL_PAYMENT_ADVICE_LIST:
            return {
                ...state,
                getApprovalPaymentAdviseListLoading: true,
                getApprovalPaymentAdviseListLoaded: false,
                getApprovalPaymentAdviseListError: null,
            }

        case GET_APPROVAL_PAYMENT_ADVICE_LIST_SUCCESS:
            return {
                ...state,
                getApprovalPaymentAdviseListLoading: false,
                getApprovalPaymentAdviseListLoaded: true,
                getApprovalPaymentAdviseListData: action.payload.success,
            }

        case GET_APPROVAL_PAYMENT_ADVICE_LIST_ERROR:
            return {
                ...state,
                getApprovalPaymentAdviseListLoading: false,
                getApprovalPaymentAdviseListLoaded: false,
                getApprovalPaymentAdviseListError: action.payload.error,
                getApprovalPaymentAdviseListData: [],
            }
        case GET_APPROVAL_PAYMENT_ADVICE_LIST_RESET:
            return {
                ...state,
                getApprovalPaymentAdviseListLoading: false,
                getApprovalPaymentAdviseListLoaded: false,
                getApprovalPaymentAdviseListError: null,
                getApprovalPaymentAdviseListData: {},
            }

        case GET_PAYMENT_ADVICE_EXCEL_REPORT:
            return {
                ...state,
                getPaymentAdviceExcelReportLoading: true,
                getPaymentAdviceExcelReportLoaded: false,
                getPaymentAdviceExcelReportError: null,
            }

        case GET_PAYMENT_ADVICE_EXCEL_REPORT_SUCCESS:
            return {
                ...state,
                getPaymentAdviceExcelReportLoading: false,
                getPaymentAdviceExcelReportLoaded: true,
                getPaymentAdviceExcelReportData: action.payload.success,
            }

        case GET_PAYMENT_ADVICE_EXCEL_REPORT_ERROR:
            return {
                ...state,
                getPaymentAdviceExcelReportLoading: false,
                getPaymentAdviceExcelReportLoaded: false,
                getPaymentAdviceExcelReportError: action.payload.error,
                getPaymentAdviceExcelReportData: [],
            }

        default:
            return state
    }
}